<template>
  <div>
    <a-page-header
      class="page-header"
      :ghost="false"
      style="margin-bottom: 16px"
    >
      <template #title>
        <a-space size="middle">
          <a-icon type="appstore"></a-icon>
          <span>办公设备</span>
        </a-space>
      </template>
      <span>办公设备包含名称、配置、IP 地址、资产编号、用途等。</span>
    </a-page-header>

    <a-card :bordered="false">
      <office-equipment-table
        :refresh="refresh"
        :tools-list="['setting', 'reload', 'search', 'leftTool', 'export']"
      ></office-equipment-table>
    </a-card>
  </div>
</template>

<script>
import OfficeEquipmentTable from '@/components/table/OfficeEquipmentTable/index.vue'

export default {
  name: 'OfficeEquipment',
  components: {
    OfficeEquipmentTable
  },
  data () {
    return {
      refresh: false
    }
  }
}
</script>
